export default __webpack_public_path__ + "static/media/flag-montserrat.e6a3f1e9.svg";